import { render, staticRenderFns } from "./InitialsCircle.vue?vue&type=template&id=70c7b2ca"
import script from "./InitialsCircle.vue?vue&type=script&lang=js"
export * from "./InitialsCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports